import React from "react";
import { Card, Divider, Typography } from "antd";
import GSM_BinStatus from "../../../components/GSuperMarket/GSM_BinStatus/GSM_BinStatus";
import "../../../styles/global-ui.css";

const GSM_BinStatusPage = ({ userData }) => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            Bin Status
          </Typography.Title>
          <Typography.Text className="page-subtitle">
            View garment supermarket inward and outward bin movement reports
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <Card className="modern-card">
        <GSM_BinStatus userData={userData} />
      </Card>
    </div>
  );
};

export default GSM_BinStatusPage;